import React from 'react'

const LandingBriefCase = () => {
  return (
      <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
      >
          <path
              d="M12 18.2002C14.2091 18.2002 16 16.4093 16 14.2002C16 11.9911 14.2091 10.2002 12 10.2002C9.79086 10.2002 8 11.9911 8 14.2002C8 16.4093 9.79086 18.2002 12 18.2002Z"
              stroke="#292D32"
              strokeWidth="1.8"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
          />
          <path
              d="M10.4375 14.3003L11.0875 14.9503C11.2775 15.1403 11.5875 15.1403 11.7775 14.9603L13.5575 13.3203"
              stroke="#292D32"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
          />
          <path
              d="M8.0008 22H16.0008C20.0208 22 20.7408 20.39 20.9508 18.43L21.7008 10.43C21.9708 7.99 21.2708 6 17.0008 6H7.0008C2.7308 6 2.0308 7.99 2.3008 10.43L3.0508 18.43C3.2608 20.39 3.9808 22 8.0008 22Z"
              stroke="#292D32"
              strokeWidth="1.8"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
          />
          <path
              d="M8 6V5.2C8 3.43 8 2 11.2 2H12.8C16 2 16 3.43 16 5.2V6"
              stroke="#292D32"
              strokeWidth="1.8"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
          />
          <path
              d="M21.6478 11C19.9178 12.26 17.9978 13.14 16.0078 13.64"
              stroke="#292D32"
              strokeWidth="1.8"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
          />
          <path
              d="M2.61719 11.2695C4.28719 12.4095 6.10719 13.2195 7.99719 13.6795"
              stroke="#292D32"
              strokeWidth="1.8"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
          />
      </svg>
  );
}

export default LandingBriefCase
